/**
 * Hämta selected polygon features baserat på lista av feature IDs
 * @param {Array} listOfFeatureIds - Array av feature IDs
 * @param {string} type - Layer type
 * @param {Object} mapState - MapStateManager instance
 * @returns {Array} Array av GeoJSON features
 */
export function getSelectedPolygonFeatures(listOfFeatureIds, type, mapState) {
        const selectedFeatures = [];
        
        if (!mapState.getTurfPolygons(type)) {
            console.warn('DistrictLoader: No turf polygons found for type', type);
            return selectedFeatures;
        }
        
        listOfFeatureIds.forEach(id => {
            const data = mapState.getTurfEntryById(type, id);
            
            if (data) {
                selectedFeatures.push({
                    ...data.feature
                });
            } else {
                console.warn('DistrictLoader: No feature data found for', id);
            }
        });

        return selectedFeatures;
}

